import { create } from 'zustand'

interface HamburgerMenuState {
  opened: boolean
  open: () => void
  close: () => void
}

export const hamburgerMenuStore = create<HamburgerMenuState>((set) => ({
  opened: false,
  open: () => set(() => ({ opened: true })),
  close: () => set(() => ({ opened: false })),
}))
